import { render, staticRenderFns } from "./accountBalances.vue?vue&type=template&id=c746cf16&"
import script from "./accountBalances.vue?vue&type=script&lang=js&"
export * from "./accountBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports